import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class LandingImagesItem extends BaseModel {
  static override constructorName = 'LandingImagesItem'

  _index: string = ''
  img: string = ''
  'img_text': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['img'])

      this.img = toCroppedImage(data.img)
    }
  }
}
